import { render, staticRenderFns } from "./Listing-Table.vue?vue&type=template&id=670c6612"
import script from "./Listing-Table.vue?vue&type=script&lang=js"
export * from "./Listing-Table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports